import { Content, List, Root, Trigger } from '@radix-ui/react-tabs';

import type { ComponentProps } from 'react';

import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';

function Tabs({ className, ...props }: ComponentProps<typeof Root>) {
  return <Root data-slot="tabs" className={cn('flex flex-col gap-2', className)} {...props} />;
}

function TabsList({ className, ...props }: ComponentProps<typeof List>) {
  return (
    <ScrollArea className="max-w-full p-[3px] pb-0">
      <List
        data-slot="tabs-list"
        className={cn(
          'text-muted-foreground flex h-9 w-max items-center justify-center',
          className
        )}
        {...props}
      />
      <ScrollBar orientation="horizontal" className="h-1.5 hidden sm:flex" />
    </ScrollArea>
  );
}

function TabsTrigger({ className, ...props }: ComponentProps<typeof Trigger>) {
  return (
    <Trigger
      data-slot="tabs-trigger"
      className={cn(
        "data-[state=active]:bg-background dark:data-[state=active]:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 text-foreground dark:text-muted-foreground inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-2 py-1 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        className
      )}
      {...props}
    />
  );
}

function TabsContent({ className, ...props }: ComponentProps<typeof Content>) {
  return (
    <Content data-slot="tabs-content" className={cn('flex-1 outline-none', className)} {...props} />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
